import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import { Typography } from '@components/Typography';

const Wrapper = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '14px 0 10px',
});

const Line = styled('div')({
    flex: 1,
    height: 1,
    background: 'var(--divider)',
});

export const DividerIconButton = styled(IconButton)({
    padding: 2,
    opacity: 0,
    transition: 'opacity 0.15s',
    '.labeled-divider:hover &': {
        opacity: 1,
    },
    '& svg': {
        width: 14,
        height: 14,
        color: 'rgba(0, 0, 0, 0.4)',
    },
});

export const LabeledDivider = ({ label, labelColor = 'var(--text-secondary)', children }) => (
    <Wrapper className="labeled-divider">
        <Line />
        <Typography variant="caption" sx={{ color: labelColor, whiteSpace: 'nowrap', flexShrink: 0 }}>
            {label}
        </Typography>
        {children}
        <Line />
    </Wrapper>
);
